import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import {
	EvaluationCompanyBuyerResponse,
	EvaluationSupplierPartsResponse,
	SaveSupplierEvaluationResult,
} from "@/main/models/response/evaluationSupplierResponse";
import { SaveSupplierEvaluationRequest } from "@/main/models/request/evaluationSupplierRequest";

export abstract class IEvaluationCompanyBuyerApi {
	abstract saveSupplierEvaluation(
		request: SaveSupplierEvaluationRequest,
	): Promise<AxiosResponse<Result<SaveSupplierEvaluationResult>>>;
	abstract getPartsToEvaluateSupplier(
		guidProcurement: string,
		guidSupplier: string | null,
	): Promise<AxiosResponse<Result<EvaluationSupplierPartsResponse[]>>>;
	abstract getSupplierEvaluationByGuid(
		guidEvaluationCompanyBuyer: string | null,
	): Promise<AxiosResponse<Result<EvaluationCompanyBuyerResponse>>>;
	abstract saveEvaluationPublic(
		saveEvaluationRequest: SaveSupplierEvaluationRequest,
	): Promise<AxiosResponse<Result<SaveSupplierEvaluationResult>>>;
}
